import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7630e57e")

_pushScopeId("data-v-7630e57e")
const _hoisted_1 = { class: "p-d-flex p-jc-end" }
const _hoisted_2 = { class: "p-d-flex p-jc-between p-ai-center p-mr-1" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_DataType = _resolveComponent("DataType")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createBlock(_component_DataTable, {
    value: _ctx.sampleData,
    showGridlines: "",
    responsiveLayout: "scroll",
    class: "p-datatable-sm",
    scrollable: true,
    scrollHeight: "65vh",
    rowHover: true,
    loading: _ctx.loading,
    resizableColumns: true,
    columnResizeMode: "fit"
  }, {
    empty: _withId(() => [
      _createTextVNode(_toDisplayString(_ctx.$t("datasource.sample_data.no.data.found")), 1)
    ]),
    loading: _withId(() => [
      _createTextVNode(_toDisplayString(_ctx.$t("datasource.sample_data.loading.data.please.wait")), 1)
    ]),
    header: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("span", _hoisted_2, _toDisplayString(_ctx.$t("upload.datasource.label.column.selection")), 1),
        _createVNode(_component_MultiSelect, {
          modelValue: _ctx.selectedColumns,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedColumns = $event)),
          options: _ctx.headers,
          style: {"width":"20em"}
        }, {
          value: _withId(() => [
            _createVNode("div", null, _toDisplayString(_ctx.$t("label.number.of.selected.columns", {
                  selected: _ctx.selectedColumns.length,
                  total: _ctx.headers.length,
                })), 1)
          ]),
          _: 1
        }, 8, ["modelValue", "options"])
      ])
    ]),
    default: _withId(() => [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectedColumns, (col) => {
        return (_openBlock(), _createBlock(_component_Column, {
          field: col,
          key: col
        }, {
          header: _withId((slotProps) => [
            _createVNode(_component_DataType, {
              dataType: _ctx.getDataType(slotProps.column.key)
            }, null, 8, ["dataType"]),
            _createTextVNode(" " + _toDisplayString(slotProps.column.key), 1)
          ]),
          _: 2
        }, 1032, ["field"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["value", "loading"]))
})